import $ from 'jquery';
import Swiper, { Lazy, Navigation } from 'swiper';
export const init = async function() {
    const sliders = $('.js-collection-categories-slider');
    if (!sliders.length) {
        return;
    }
    const activeCollectionIndex = $('.CollCategories-link').index($('.CollCategories-link.active'));
    Swiper.use([
        Lazy,
        Navigation
    ]);
    const swiperOptions = {
        initialSlide: activeCollectionIndex,
        slidesPerView: 2.5,
        spaceBetween: 11,
        freeMode: true,
        autoHeight: false,
        watchSlidesProgress: true,
        direction: 'horizontal',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            1024: {
                slidesPerView: 6.3,
                spaceBetween: 38
            }
        },
        on: {
            slideChange () {
                const totalSlides = this.slides.length;
                const currentIndex = this.activeIndex + 1;
                const swiperWrapper = this.$wrapperEl[0];
                const slidesPerView = typeof this.params.slidesPerView === 'number' ? this.params.slidesPerView : 1;
                if (swiperWrapper) {
                    if (currentIndex > totalSlides - slidesPerView) {
                        swiperWrapper.classList.add('last-slide-visible');
                    } else {
                        swiperWrapper.classList.remove('last-slide-visible');
                    }
                }
            }
        }
    };
    const swiper = new Swiper('.js-collection-categories-slider', swiperOptions);
    if (sliders.find('.swiper-slide').length <= 7) {
        $('.js-collection-categories-slider .swiper-scrollbar').addClass('--hide-desktop');
    }
};
